import { removePhoneFormat } from '@src/services/utils'
import { ReactNode, useId } from 'react'
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'

interface Props<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  label: ReactNode
  className?: string
}

const PhoneExtInput = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  className,
}: Props<TFieldValues>) => {
  const id = useId()
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, ...field }, fieldState: { invalid, error } }) => {
        return (
          <div className={`control-group ${className} ${invalid && 'error'}`}>
            <label htmlFor={id}>{label}</label>
            <div className="phone-input-wrapper">
              <input
                {...field}
                id={id}
                type="text"
                inputMode="tel"
                placeholder="( ____ )"
                onChange={(e) => onChange(removePhoneFormat(e.target.value))}
                maxLength={10}
              />
            </div>
            {error?.message && error.type !== 'required' && <span className="error-message">{error.message}</span>}
          </div>
        )
      }}
    />
  )
}

export default PhoneExtInput
